import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { VirtualBrand } from '~/Api/Analytics/VirtualBrand';
import { Pagination } from '~/Api/Pagination';
import {
	BrandQuery,
	fetchMoreHistory,
	Record,
	selectHistory,
	State as HistoryState,
} from '~/MedicinalBrandsAnalytics/VirtualBrand/History';
import { ThunkDispatch } from '~/Store';

import HistoryPanel from './HistoryTab';

interface State {
	medicinalBrandsAnalyticsHistory: HistoryState;
}

interface OwnProps {
	virtualBrand: VirtualBrand;
	currency: string | null;
}

function mapStateToProps(
	{ medicinalBrandsAnalyticsHistory }: State,
	{ virtualBrand, currency }: OwnProps
): {
	history: Record[] | null;
	pagination: Pagination | null;
	isFetching: boolean;
} {
	const historyState = selectHistory(medicinalBrandsAnalyticsHistory, new BrandQuery(virtualBrand.id, currency));

	return {
		history: historyState?.items || null,
		pagination: historyState?.pagination || null,
		isFetching: Boolean(historyState?.isFetching),
	};
}

function load(id: string, currency: string | null) {
	return (dispatch: ThunkDispatch<AnyAction>) => {
		const query = new BrandQuery(id, currency);
		if (query.isValid) {
			dispatch(fetchMoreHistory(query, 20));
		}
	};
}

const actions = {
	onLoad: load,
};

export default connect(mapStateToProps, actions)(HistoryPanel);
